module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lWPoG"))).then(() => parcelRequire('3a9aZ'));